import React from "react"

import { useQuery, useQueryClient } from "@tanstack/react-query"

import { useAuth } from "src/context/AuthContext"

export function useBackendAPIVersion() {
  const { api, isAuthenticated } = useAuth()
  return useQuery({
    queryFn: async () => {
      const response = await api.getBackendAPIVersion()
      if (response.kind !== "ok") {
        throw new Error("Failed to fetch backend API version")
      }
      return response.version
    },
    queryKey: ["backendAPIVersion"],
    refetchOnMount: true,
    enabled: isAuthenticated,
  })
}

export function useClearApiCache() {
  const queryClient = useQueryClient()

  return React.useCallback(() => {
    queryClient.removeQueries({ queryKey: ["backendAPIVersion"] })
  }, [queryClient])
}
